<template>
  <div>
    <template v-if="isPublic && currentClass != 'PublicDashboard'">
      <auth-layout></auth-layout>
    </template>
    <template v-else>
      <template v-if="loggedIn">
        <dashboard-layout></dashboard-layout>
      </template>
      <template v-else>
        <auth-layout> </auth-layout>
      </template>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "DashboardIndex",

  components: {
    DashboardLayout: () => import("./Layout/DashboardLayout"),
    AuthLayout: () => import("./Pages/AuthLayout")
  },

  data: () => ({
    expandOnHover: false,
    currentClass: "",
    isPublic: false
  }),

  watch: {
    $route(val) {
      this.currentClass = val.name;
      this.isPublic = val.name.includes("Public") ? true : false;
    },
    loggedIn(val) {
      if (!this.isPublic && !this.loggedIn) {
        this.$router.push({
          name: "Login"
        });
      }
    }
  },

  created() {
    this.currentClass = this.$route.name;
    this.isPublic = this.$route.name.includes("Public") ? true : false;
    if (this.loggedIn && this.$route.name === "PublicDashboard") {
      this.$router.push({
        name: "AdminDashboard"
      });
    } else if (!this.isPublic && !this.loggedIn) {
      this.$router.push({
        name: "Login"
      });
    }
  },
  computed: {
    ...mapState(["loggedIn"])
  },

  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN"
    })
  }
};
</script>
